import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=e463aeee&scoped=true"
import script from "./add-user.vue?vue&type=script&lang=js"
export * from "./add-user.vue?vue&type=script&lang=js"
import style0 from "./add-user.vue?vue&type=style&index=0&id=e463aeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e463aeee",
  null
  
)

export default component.exports